<script lang="ts" setup>
import {NConfigProvider, NDialogProvider, NMessageProvider, NNotificationProvider} from 'naive-ui'
import {districarThemeOverrides} from '@/theme'
import {onMounted, watch} from 'vue'
import {useRoute} from 'vue-router'
import {useThemeStore} from "@/stores/theme-store";
import {useLanguageStore} from "@/stores/language-store";
import {useAuthStore} from "@/stores/authentication-store";
import SignalRProvider from "@/components/providers/signal-r-provider.vue";
import FeatureTogglesProvider from "@/components/providers/feature-toggles-provider.vue";
import I18nProvider from "@/components/providers/i18n-provider.vue";
import ErrorMessageProvider from '@/components/providers/error-message-provider.vue';
import PlanRunProvider from "@/components/providers/plan-run-provider.vue";

const route = useRoute();

watch(() => route.meta?.layout as string | undefined, async (metaLayout) => {
    },
    {immediate: true}
)

const themeStore = useThemeStore();
const languageStore = useLanguageStore();
const authStore = useAuthStore();

onMounted(async () => {
  await authStore.ensureHydrated();
  themeStore.determineSize(document.body.clientWidth);
  window.addEventListener('resize', async () => {
    themeStore.determineSize(document.body.clientWidth);
  });
})
</script>

<template>
  <n-config-provider
      :date-locale="languageStore.currentDateLocale"
      :locale="languageStore.currentLocale"
      :theme-overrides="districarThemeOverrides">
    <n-dialog-provider>
      <n-notification-provider>
        <n-message-provider>
          <error-message-provider/>
          <component :is="route.meta.layout">
            <router-view :key="route.path"/>
          </component>
          <!--
            Binnen de providers en niet erbuiten zoals de andere providers: de voortgangsweergave kon nog
            zonder, maar de samenvatting toont kentekenplaten en die vragen een message-provider. Als sibling
            van de layout blijft hij bij een routewissel gewoon staan, en hij erft meteen het thema.
          -->
          <plan-run-provider/>
        </n-message-provider>
      </n-notification-provider>
    </n-dialog-provider>
  </n-config-provider>
  <signal-r-provider/>
  <feature-toggles-provider/>
  <i18n-provider/>
</template>

<style lang="scss">
</style>
